define('plugin/product/view/ProductDeliveryView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Product delivery view
     *
     * @class ProductDeliveryView
     */
    return LayoutView.extend({

        template: '#product_delivery_view',

        modelEvents: {
            'sync': 'render'
        }

    });

});
